module.exports = __webpack_public_path__ + "static/img/wxpng.aae0033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxpng.jpg
// module id = JFXU
// module chunks = 11